import merge from 'lodash/merge';
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import { FieldTransformer } from './FieldTransformers/FieldTransformers';

const queryStringFiltersConfig = { arrayFormat: 'comma' } as const;

export const toRequestQuery = (formValues: any, filterTransformers: FieldTransformer[]) => {
  return filterTransformers.reduce((acc, field) => {
    return merge(acc, field.toRequestQuery(formValues));
  }, {} as any);
};
export const toPageQuery = (formValues: any, filterTransformers: FieldTransformer[]) => {
  return filterTransformers.reduce((acc, field) => {
    return merge(acc, field.toPageQuery(formValues));
  }, {} as any);
};

export const fromPageQuery = (queryValues: any, filterTransformers: FieldTransformer[]) => {
  return filterTransformers.reduce((acc, field) => {
    return merge(acc, field.fromPageQuery(queryValues));
  }, {} as any);
};

export const parseFilterQuery = (query: string) => queryString.parse(query, queryStringFiltersConfig);

export const stringifyFilters = (queryObject: Record<string, any>) => {
  //filter out the _gl property from Google Analytics if it exists
  const { _gl, ...filteredQuery } = queryObject;
  return `?${queryString.stringify(filteredQuery, queryStringFiltersConfig)}`;
};

export const omitEmptyValues = (values: any) =>
  omitBy(values, (value: unknown) => (typeof value === 'object' ? isEmpty(value) : value === '' || value === undefined));
